export default __webpack_public_path__ + "static/media/6-1.b96aa0b8.png";